import React from 'react';
import CTA from '../components/CTA';

const QuemSomos = () => {
    return (
        <>
            {/* Main */}
            <section className="wrapper style1">
                <div className="container">
                    <div className="row gtr-200">
                        <div className="col-4 col-12-narrower">
                            <div id="sidebar">
                                {/* Sidebar */}
                                <section>
                                    <h3>Transformando Necessidade em Oportunidade</h3>
                                    <p>
                                        Diante da impossibilidade de se engajar formalmente no mercado de trabalho devido aos
                                        cuidados especiais exigidos por seus filhos, Fabiane ponderou sobre a ideia de buscar uma
                                        fonte de renda, embora as possibilidades ainda parecessem incertas.
                                    </p>
                                    <p>
                                        Foi após a aquisição de um simples produto que surgiu o insight para empreender no campo da
                                        impressão 3D. A solução proporcionada por esse modesto item foi tão elegante que inspirou a
                                        decisão de investir na primeira impressora 3D no início de 2022, com o objetivo de criar soluções tão
                                        impactantes e satisfatórias quanto aquela que havia experimentado.
                                    </p>
                                </section>
                            </div>
                        </div>
                        <div className="col-8 col-12-narrower imp-narrower">
                            <div id="content">
                                {/* Content */}
                                <article>
                                    <header>
                                        <h2>UMA EMPRESA FAMILIAR</h2>
                                        <p><strong>G</strong>abriel e <strong>M</strong>elinda emprestam seus nomes à empresa,
                                            enquanto os pais a conduzem com dedicação e paixão genuína, <strong>de coração</strong>.
                                        </p>
                                    </header>

                                    <span className="image featured">
                                        <img src="/images/familia-02.png" alt="Família GM de Coração" />
                                    </span>

                                    <p>
                                        Olá, somos Fabiane e Andre, orgulhosos pais do Gabriel e da Melinda. Nossa família é atípica
                                        e única, e é essa singularidade que nos inspira a empreender constantemente.
                                    </p>
                                    <p>
                                        Os desafios que enfrentamos como pais de crianças atípicas são vastos e complexos. Exigem de
                                        nós uma dose extra de tudo: compreensão, dedicação, persistência e paciência - não apenas
                                        com nossos filhos, mas também com o mundo ao nosso redor. No entanto, mais do que apenas
                                        superar obstáculos, essa jornada nos ensinou a cultivar um espírito empreendedor mais forte
                                        do que nunca.
                                    </p>

                                    <h3>ALÉM DA IMPRESSÃO 3D</h3>
                                    <p>
                                        <strong>Nosso instinto empreendedor vai muito além de imprimir e vender pela internet.</strong><br />
                                        Desde o início, assim como muitos que entram no universo da impressão 3D, experimentamos um
                                        pouco de tudo, em busca de propósito. Com o tempo, encontramos o que realmente nos motiva:
                                        criar brinquedos — mas não brinquedos comuns.
                                        <br />
                                        Nos dedicamos aos brinquedos sensoriais, projetados com carinho para crianças, adultos e,
                                        especialmente, para pessoas neurodivergentes. São itens que estimulam o tato, a percepção e
                                        o entendimento mecânico, sempre com foco absoluto em segurança e funcionalidade.
                                        <br />
                                        Mais do que produtos, criamos ferramentas de conexão, aprendizado e inclusão.
                                    </p>

                                    <h3>POR QUE COMPRAR COM A GENTE?</h3>
                                    <p> Ao escolher nossos produtos, você vai muito além de uma simples compra. Você apoia uma
                                        família atípica que enfrenta diariamente os altos custos com medicamentos manipulados,
                                        deslocamentos frequentes para terapias e consultas especializadas — uma rotina que exige força,
                                        resiliência e muitos recursos. Cada venda é uma forma de suporte real, e em troca você recebe
                                        itens incríveis, feitos com propósito, cuidado que não são encontrados em nenhuma outra
                                        loja. Juntos, podemos transformar desafios em conquistas.
                                    </p>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CTA />
        </>
    );
};

export default QuemSomos;
